export const isDevelopMode = () => {
    return typeof window != 'undefined' && window.location.href.startsWith("http://localhost");
}